import { css } from "@emotion/react";
import { useTheme } from "@mui/material";

import QuestListBody from "~/components/category/[id]/quest/QuestListBody";
import { QuestOrder, QuestState } from "~/components/category/[id]/quest/lib";
import { Props } from "~/components/category/[id]/quest/type";
import { QuestDurationStatus } from "~/domains/quest/lib";
import { mediaQueryIsDesktop, mediaQueryIsMobile } from "~/lib/client/design";

const CollaborationQuestList = ({
  collaboratedQuests,
  selectedQuestStatus,
  selectedSort,
  selectedDurationStatus,
  selectedQuestGenreTags,
}: {
  collaboratedQuests: Props["category"]["quests"];
  selectedQuestStatus: QuestState[];
  selectedSort: QuestOrder;
  selectedDurationStatus: QuestDurationStatus;
  selectedQuestGenreTags: Props["category"]["quests"][number]["questGenreTags"];
}) => {
  const theme = useTheme();
  return (
    <section
      css={css`
        background: #fbe9e9;

        ${mediaQueryIsDesktop(css`
          margin-left: -2rem;
          margin-right: -2rem;
        `)}

        ${mediaQueryIsMobile(css`
          padding: 1rem;
          margin-bottom: 1rem;
        `)}

        padding-bottom: 3rem;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        <h3
          css={css`
            width: fit-content;
            margin-left: 1rem;
            color: ${theme.palette.text.primary};

            &:after {
              content: "";
              background: ${theme.palette.primary.main};
              margin-top: 0.5rem;
              display: flex;
              width: 100%;
              height: 2px;
            }
          `}
        >
          コラボクエスト
        </h3>
      </div>
      <div css={questListBodyContainerStyle}>
        <QuestListBody
          quests={collaboratedQuests}
          selectedQuestStatus={selectedQuestStatus}
          selectedSort={selectedSort}
          selectedDurationStatus={selectedDurationStatus}
          selectedQuestGenreTags={selectedQuestGenreTags}
        />
      </div>
    </section>
  );
};

const questListBodyContainerStyle = css`
  ${mediaQueryIsDesktop(css`
    margin-top: 2rem;
    margin-inline: 2rem;
  `)}
`;

export default CollaborationQuestList;
